import React, { useState } from 'react';
import './TabsPage.css'; // We'll create this CSS file
import CoursePage from './CoursePage';
import CourseListing from './CourseListing';
import MyFooter from './MyFooter';
import TrainingListing from './TainingListing';


const TabsPage = () => {
  const [activeTab, setActiveTab] = useState('courses');

  // Sample data
  const courses = [
    { id: 1, title: 'React Fundamentals', duration: '4 weeks', level: 'Beginner' },
    { id: 2, title: 'Advanced JavaScript', duration: '6 weeks', level: 'Intermediate' },
    { id: 3, title: 'Node.js Backend', duration: '8 weeks', level: 'Advanced' },
  ];

  const trainings = [
    { id: 1, title: 'Web Development Bootcamp', date: 'June 15-30, 2023', location: 'Online' },
    { id: 2, title: 'UI/UX Workshop', date: 'July 10-12, 2023', location: 'New York' },
    { id: 3, title: 'DevOps Training', date: 'August 5-20, 2023', location: 'San Francisco' },
  ];

  return (
    <>
    <div className="tabs-container">
      <h1 className="page-title">CDPC</h1>
      
      <div className="tabs-header">
        <button
          className={`tab-button ${activeTab === 'courses' ? 'active' : ''}`}
          style={{ '--tab-color': '#4CAF50' }} // Green for courses
          onClick={() => setActiveTab('courses')}
        >
          COURSES
        </button>
        <button
          className={`tab-button ${activeTab === 'training' ? 'active' : ''}`}
          style={{ '--tab-color': '#4CAF50' }} // Green for courses
          onClick={() => setActiveTab('training')}
        >
          TRAINING
        </button>
       
      </div>

      <div className="tab-content">
        {activeTab === 'courses' ? (
          <div className="courses-tab">
           <CourseListing/>
          </div>
        ) : (
          <div className="training-tab">
            <TrainingListing/>        
          </div>
        )}
      </div>
     
    </div>
    
     </>
  );
};

export default TabsPage;